/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoveltyCalcKeyFigureYearSegmentDto
 */
export interface NoveltyCalcKeyFigureYearSegmentDto {
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcKeyFigureYearSegmentDto
     */
    current?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcKeyFigureYearSegmentDto
     */
    previousYear?: number | null;
}

/**
 * Check if a given object implements the NoveltyCalcKeyFigureYearSegmentDto interface.
 */
export function instanceOfNoveltyCalcKeyFigureYearSegmentDto(value: object): value is NoveltyCalcKeyFigureYearSegmentDto {
    return true;
}

export function NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json: any): NoveltyCalcKeyFigureYearSegmentDto {
    return NoveltyCalcKeyFigureYearSegmentDtoFromJSONTyped(json, false);
}

export function NoveltyCalcKeyFigureYearSegmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcKeyFigureYearSegmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : json['current'],
        'previousYear': json['previousYear'] == null ? undefined : json['previousYear'],
    };
}

export function NoveltyCalcKeyFigureYearSegmentDtoToJSON(json: any): NoveltyCalcKeyFigureYearSegmentDto {
    return NoveltyCalcKeyFigureYearSegmentDtoToJSONTyped(json, false);
}

export function NoveltyCalcKeyFigureYearSegmentDtoToJSONTyped(value?: NoveltyCalcKeyFigureYearSegmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
        'previousYear': value['previousYear'],
    };
}

